import request from '@/utils/request.js';
import { FORUM_API_URL } from '@/config/index.js';

// 前端埋点数据上报
export const eventTrackApi = data =>
  request({
    baseURL: FORUM_API_URL,
    url: '/platform-box-user/user/event-track',
    data,
    method: 'post',
    // 论坛域接口成功为 code=0 / success=true，需走论坛响应解析
    isForumRequest: true,
  });
